import { executeNodejsRequest } from './NodejsHttpRequestUtils.js';
/**
 * Adapter for Node Https module to be used as HttpClient
 */
export class NodejsHttpClient {
    https;
    constructor(https) {
        this.https = https;
    }
    async request(url, requestOptions) {
        return await executeNodejsRequest(this.https, url, requestOptions, (data) => JSON.stringify(data));
    }
}
//# sourceMappingURL=NodejsHttpClient.js.map